module.exports = __webpack_public_path__ + "img/paulo.54de62a8.jpeg";